interface ValueItem {
  emoji: string;
  title: string;
  description: string;
}

const items: ValueItem[] = [
  {
    emoji: '🧮',
    title: 'Easy Salary Math',
    description:
      'Just enter the hourly rate or gross amount. We handle the rest.',
  },
  {
    emoji: '🏦',
    title: 'NIB Payments',
    description:
      'Automatic calculations and reporting for national insurance.',
  },
  {
    emoji: '🚀',
    title: 'Quick Conversion',
    description: 'Switch from your old system in under 10 minutes flat.',
  },
  {
    emoji: '💖',
    title: 'Happy Employees',
    description:
      'Digital payslips delivered straight to their inbox every time.',
  },
];

export function ValueGrid() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
      style={{ borderBottom: 'var(--border-medium)' }}
    >
      {items.map((item, i) => (
        <div
          key={item.title}
          className="px-10 py-14 flex flex-col gap-6 hover:bg-white transition-colors duration-300"
          style={{
            borderRight:
              i < items.length - 1 ? 'var(--border-light)' : 'none',
          }}
        >
          <div className="text-[2rem]">{item.emoji}</div>
          <div>
            <div className="font-display text-xl font-bold text-deep-ink">
              {item.title}
            </div>
            <div className="text-[0.95rem] text-gray-500 mt-2 font-body">
              {item.description}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
